import classNames from "classnames";
import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import {
  BUTTON_ICON_ONLY_SIZE_CLASSES,
  BUTTON_SIZE_CLASSES,
  BUTTON_VARIANT_CLASSES,
} from "./Button.constants";
import { ButtonProps } from "./Button.types";

export function Button({
  variant = "primary",
  size = "md",
  fullWidth = false,
  width = 100,
  autoWidth,
  disabled,
  loading,
  iconOnly,
  leftIcon,
  rightIcon,
  className,
  children,
  ...props
}: ButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <button
      className={classNames(
        "inline-flex items-center justify-center gap-2 rounded-lg font-Manrope text-sm font-medium",
        "transition-all duration-300",
        "disabled:cursor-not-allowed",
        BUTTON_VARIANT_CLASSES[variant],
        iconOnly
          ? BUTTON_ICON_ONLY_SIZE_CLASSES[size]
          : BUTTON_SIZE_CLASSES[size],
        fullWidth ? "w-full" : !iconOnly && !autoWidth && `w-[${width}px]`,
        className,
      )}
      disabled={isDisabled}
      {...props}>
      {loading && (
        <div className={"h-4 w-4 animate-spin"}>
          <AiOutlineLoading3Quarters size={16} />
        </div>
      )}
      {!loading && leftIcon && (
        <span className={"flex shrink-0 items-center text-current"}>
          {leftIcon}
        </span>
      )}
      {!iconOnly && children}
      {!loading && rightIcon && (
        <span className={"flex shrink-0 items-center text-current"}>
          {rightIcon}
        </span>
      )}{" "}
    </button>
  );
}
